import React from 'react';
import { withTranslation } from 'react-i18next';
import { Label, Table } from 'semantic-ui-react';

const QuantityWithUnitCell = ({ rowValues, entryRecord, index, t }) => {
  let unitLabel;
  if (rowValues.GEN_STATE === 'STATE_SOLID' || rowValues.GEN_STATE === 'STATE_GAS') {
    unitLabel = (
      <Label>{t('inventory.details.page.chemical.container.quantity.input.label.kilos')}</Label>
    );
  } else if (rowValues.GEN_STATE === 'STATE_LIQUID') {
    unitLabel = (
      <Label>{t('inventory.details.page.chemical.container.quantity.input.label.liters')}</Label>
    );
  }

  return (
    <Table.Cell key={rowValues.ID + index} className="tableCell tableCellReducedPadding2">
      {rowValues[entryRecord.key]} {unitLabel}
    </Table.Cell>
  );
};

export default withTranslation()(QuantityWithUnitCell);
